<template>
  <div class="customerList">
    <!-- <van-search
      v-model="searchValue"
      placeholder="请输入被保人保单号/姓名/证件号"
      show-action
      @search="searchAjax()"
    >
      <template #action>
        <div @click="searchAjax()">搜索</div>
      </template>
    </van-search> -->
    <van-list
      v-if="list && list.length"
      v-model="listLoading"
      :finished="finished"
      finished-text="没有更多了"
      @load="nextPage()"
    >
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <div class="row">
          <span class="key">姓名：</span>
          <span class="text">{{ item.customerName }}</span>
        </div>
        <div class="row">
          <span class="key">手机号：</span>
          <span class="text">{{ item.customerMobile }}</span>
        </div>
        <div class="row">
          <span class="key">保单号：</span>
          <span class="text">{{ item.policyNo || '-' }}</span>
        </div>
        <div class="row">
          <span class="key">证件号：</span>
          <span class="text">{{ item.idNo || '-' }}</span>
        </div>
      </div>
    </van-list>
    <van-empty description="暂无内容" v-if="!list.length && !listLoading" />
  </div>
</template>

<script>
import { pageTools } from "@/api/mixins";
export default {
  mixins: [pageTools],
  data() {
    return {
      searchValue: "",
    };
  },
  computed: {},
  created() {
    this.initListAjax("/api/customerList");
  },
  methods: {
    setListParams(params){
      params.searchValue = this.searchValue
    }
  },
};
</script>

<style lang="scss" scoped>
.van-search{
  position: fixed;
  width: 100%;
  top: 0;
}
.van-list{
  // margin-top: 120px;
}
.list-item {
  background: #fff;
  border-radius: 10px;
  padding: 20px 30px;
  margin: 20px 30px 0;
  box-shadow: 0px 0px 20px #e7ecf6;
  .row {
    margin-bottom: 10px;
    font-size: 28px;
    font-family: PingFang SC;
    .key {
      color: #8a9095;
    }
    .text {
      color: #3c464f;
    }
  }
}
</style>
